export default __webpack_public_path__ + "static/media/img-v3-map.776c23a6.png";